import { useAtom } from 'jotai';
import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { extensionVersionService } from '@/services/extensionVersion.service';

const extensionVersionsPageAtom = atom<{ page: number; limit: number }>({
  page: 1,
  limit: 50,
});

const extensionVersionsQueryAtom = atomWithQuery((get) => {
  const { page, limit } = get(extensionVersionsPageAtom);
  return {
    queryKey: ['extension-versions', page, limit],
    queryFn: () => extensionVersionService.getVersions({ page, limit }),
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  };
});

export function useExtensionVersions() {
  const [query] = useAtom(extensionVersionsQueryAtom);
  return query;
}

export function useExtensionVersionsPagination() {
  return useAtom(extensionVersionsPageAtom);
}
